// Сам скрипт на проде другой, этот только для демонстрации
function privacyPolicy() {
    document.querySelector('#tc-privacy-policy').style.display = 'none';
        document.cookie = `PRIVACY_POLICY=1; expires=${new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 365).toGMTString()}; SameSite=Lax; path=/`;
}

window.privacyPolicy = privacyPolicy;

// // На проде это не нужно, так как панель не будет показана если php видит cookie PRIVACY_POLICY
// if (document.cookie.replace(/(?:(?:^|.*;\s*)PRIVACY_POLICY\s*\=\s*([^;]*).*$)|^.*$/, "$1") !== '1') {
//     document.querySelector('#tc-privacy-policy').style.display = 'block';
// }